<template>
  <div>
    <div class="text-center login-logo"><img src="/static/img/logo.svg"/></div>
    <form @submit.prevent="login">
      <div class="form-group row">
        <label for="email" class="col-sm-2 col-form-label">{{ $t('login.un') }}</label>
        <div class="col-sm-8">
        <input type="text" class="form-control" id="email" name="email" v-model="email"/>
        </div>
        <div class="col-sm-2">&nbsp;</div>
      </div>
      <div class="form-group row">
        <label for="password" class="col-sm-2 col-form-label">{{ $t('login.pw') }}</label>
        <div class="col-sm-8">
        <input type="password" class="form-control" id="password" name="password" v-model="password"/>
        </div>
        <div class="col-sm-2">&nbsp;</div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2"></span>
        <div class="col-sm-10">
        <button class="btn btn-success">{{ $t('login.btn') }}</button>
        </div>
      </div>
    </form>
    <div v-if="feedback" class="alert alert-danger">{{ feedback }}</div>
  </div>
</template>

<script>

import firebase from 'firebase'

export default {
  name: 'Login',
  data () {
    return {
      email: null,
      password: null,
      feedback: null
    }
  },
  methods: {
    login () {
      if(this.email && this.password) {
        this.feedback = null;
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(cred => {
          this.$router.push({name: 'Sites'});
        }).catch(err => {
          this.feedback = err.message;
        });
      } else {
        this.feedback = this.$t('login.err.empty');
      }
    }
  }
}
</script>

<style>
.login-logo {
  transform: scale(0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue